/**
 * NotFoundPage — affichage 404 bilingue (refonte 9.P.1).
 *
 * Deux usages :
 *  1. Zone protégée (wrappée par <AppShell>) → garde sidebar/topbar visibles.
 *  2. Hors zone protégée (route catch-all publique) → fallback minimaliste.
 *
 * Le composant ne sait pas dans quel contexte il est ; c'est App.tsx qui
 * décide en l'incluant ou non dans <AppShell>. La marge interne ci-dessous
 * fonctionne pour les 2 cas.
 */

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { KollectiviaMark } from "../components/brand/KollectiviaMark";

export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <div className="mx-auto flex max-w-xl flex-col items-center py-16 text-center">
      <KollectiviaMark size={64} variant="mono" glow={false} ariaLabel="Kollectivia" />
      <p
        aria-hidden="true"
        className="mt-6 text-7xl font-semibold tracking-tight text-slate-200"
      >
        404
      </p>
      <h1 className="mt-2 text-2xl font-semibold tracking-tight text-slate-900">
        {t("errors.not_found.title")}
      </h1>
      <p className="mt-2 text-sm text-slate-600">{t("errors.not_found.subtitle")}</p>
      <Link
        to="/"
        className="mt-8 inline-flex touch-manipulation items-center justify-center rounded-lg bg-brand-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-brand-700 active:bg-brand-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 motion-reduce:transition-none"
      >
        {t("errors.not_found.back_home")}
      </Link>
    </div>
  );
}
